import { battleProcedureModule } from "./battle-procedure/module";
import { ordersReaderModule } from "./orders-reader/module";
import { radioProcedureModule } from "./radio-procedure/module";
import type { TrainingModule } from "./types";

export const moduleRegistry: readonly TrainingModule[] = Object.freeze([
  ordersReaderModule,
  battleProcedureModule,
  radioProcedureModule,
]);
